import { componentProvider } from 'js-component-framework';
import LoginForm from './login-form';

const loginFormConfig = {
  name: 'login-form',
  component: LoginForm,
};

componentProvider(loginFormConfig);
